<template>
    <!-- Sidebar -->
    <div class="d-flex flex-column flex-shrink-0 bg-light sidebar-responsive border-end" :class="{active : isActive}">
        <div class="text-center my-3">
            <span class="sidebar-welcome" style="font-size: 20px;">Welcome back, {{ leadData.first_name }}!</span>
        </div>

<!--        new buttons-->
        <div class="list-group mx-0" style="border-radius: 0 3px 3px 0;">
            <a role="button"  class="list-group-item list-group-item-action py-4 bg-warning bg-opacity-25" :title="'Your offers have expired since the last time you applied on ' + leadData.created_at">
                <div class="d-flex w-100 justify-content-between">
                    <h5 class="my-0"><i class="fa-solid fa-triangle-exclamation btn-icon text-warning" style="font-size: 18px; margin-right: 12px;"></i>Your offers expired</h5>
                </div>
            </a>
            <a role="button" class="list-group-item list-group-item-action py-4" @click.prevent="$emit('menuOptionSelected', 'product_selection')">
                <div class="d-flex w-100 justify-content-between">
                    <h5 class="my-0"><i class="fa-solid fa-list-check btn-icon" style="font-size: 18px; margin-right: 12px;"></i>Product Selection</h5>
                </div>
            </a>
            <a :href="settings.newApplicationUrl" class="list-group-item list-group-item-action py-4" target="_blank">
                <div class="d-flex w-100 justify-content-between">
                    <h5 class="my-0"><i class="fa-solid fa-plus btn-icon btn-icon" style="font-size: 18px; margin-right: 12px;"></i>Start New Application</h5>
                </div>
            </a>
            <a :href="settings.memberPortalUrl" class="list-group-item list-group-item-action py-4" target="_blank">
                <div class="d-flex w-100 justify-content-between">
                    <h5 class="my-0"><i class="fa-solid fa-gauge-high btn-icon" style="font-size: 18px; margin-right: 12px;"></i>Free Credit Score</h5>
                </div>
            </a>
        </div>

        <!-- Sidebar Menu -->
<!--        <ul class="nav nav-pills flex-column mb-auto">-->
<!--        </ul>-->

        <!-- User Dropdown moved to the bottom -->
<!--        <div class="dropdown">-->
<!--            <hr>-->
<!--            <a href="#" class="d-flex align-items-center link-dark text-decoration-none dropdown-toggle" id="dropdownUser" data-bs-toggle="dropdown" aria-expanded="false">-->
<!--                <i class="fa-solid fa-user btn-icon" style="font-size: 18px; margin-right: 12px;"></i>-->
<!--                <strong v-if="leadData.first_name ?? null">{{ leadData.first_name }}</strong>-->
<!--            </a>-->
<!--            <ul class="dropdown-menu text-small shadow" aria-labelledby="dropdownUser">-->
<!--                <li><a class="dropdown-item" :href="settings.newApplicationUrl" target="_blank">Start New Application...</a></li>-->
<!--                <li><hr class="dropdown-divider"></li>-->
<!--                <li><a class="dropdown-item" href="https://compare.loanscanada.ca/login" target="_blank">Login</a></li>-->
<!--            </ul>-->
<!--        </div>-->
    </div>

</template>
<script setup>
import { computed, onMounted } from 'vue';

const props = defineProps({
    settings: {
        type: Object,
        required: true,
    },
    leadData: {
        type: Object,
        required: false,
        default: () => ({}),
    },
});

const emit = defineEmits(['menuOptionSelected', 'updateSettings']);

const isActive = computed(() => {
    return props.settings.sidebar.isActive;
});

onMounted(() => {
    if (props.settings.isMobile && !props.settings.sidebar.firstLoadWasAttempted) {
        emit('updateSettings', { sidebar: { isActive: false, firstLoadWasAttempted: true } });
    }
});
</script>
